import script from "./ChosesServer.vue?vue&type=script&setup=true&lang=js"
export * from "./ChosesServer.vue?vue&type=script&setup=true&lang=js"

import "./ChosesServer.vue?vue&type=style&index=0&id=67a0a9cd&lang=scss&scoped=true"

import exportComponent from "/builds/aquaverse/thales/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67a0a9cd"]])

export default __exports__